import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class CreateGrievanceService {

  constructor(public httpClient: HttpClient) { }

  //submit rest
  async submitGrievance(data) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.raiseGrievanceForMhadaUser, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


  //load grievance type rest
  async loadGrievance(boardId: any) {
    const body = {
      bdId: boardId
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceBybdid, body)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load board rest
  async loadBoard() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadBoard, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //check duplicate grievance rest
  async isCheckDeuplicate(data) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.isCheckDuplicateGrievance, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  async loadFaqLink(grievanceTypeId){
    const data = { 'grievanceTypeId': grievanceTypeId, };
    // const url = (await grievanceServerUrl) + "loadApplication";
    // return new Promise((resolve) => {
    //   this.httpClient
    //     .post(url, data)
    //     .toPromise()
    //     .then((res) => {
    //       resolve(res);
    //     })
    //     .catch((resp: Response) => {
    //       resolve(resp);
    //     });
    // });

    return "https://www.tutorialspoint.com/java_cryptography/java_cryptography_message_digest.htm"
  }
}
